module.exports = __webpack_public_path__ + "static/assets/75e825d30f294735fcc1468bd74cdb71.png";